import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import useScrollToEnd from '../hooks/useScrollToEnd';
import useSticky from '../hooks/useSticky';
import useStyleToClassName from '../hooks/internal/useStyleToClassName';
var ROOT_STYLE = {
  backgroundColor: 'rgba(0, 0, 0, .2)',
  borderRadius: 10,
  borderWidth: 0,
  bottom: 5,
  cursor: 'pointer',
  height: 20,
  outline: 0,
  position: 'absolute',
  right: 20,
  width: 20,
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, .4)'
  },
  '&:active': {
    backgroundColor: 'rgba(0, 0, 0, .6)'
  }
};
var AutoHideFollowButton = function AutoHideFollowButton(_ref) {
  var children = _ref.children,
    className = _ref.className;
  var _useSticky = useSticky(),
    _useSticky2 = _slicedToArray(_useSticky, 1),
    sticky = _useSticky2[0];
  var rootCSS = useStyleToClassName()(ROOT_STYLE);
  var scrollToEnd = useScrollToEnd();
  return !sticky && /*#__PURE__*/React.createElement("button", {
    className: classNames(rootCSS, (className || '') + ''),
    onClick: scrollToEnd,
    type: "button"
  }, children);
};
AutoHideFollowButton.defaultProps = {
  children: undefined,
  className: ''
};
AutoHideFollowButton.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string
};
export default AutoHideFollowButton;